// external libs
import { ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { switchMap, catchError } from 'rxjs/operators'
import Api from '../Services/SuriApi'

// redux
import GeneralActions, { GeneralTypes } from '../Redux/GeneralRedux'

const GetOperatingHoursEpic = action$ => (
  action$.pipe(
    ofType(GeneralTypes.ON_GET_OPERATING_HOURS_REQUEST),
    switchMap(action => (
      from(Api.operatingHours(action.data)).pipe(
        switchMap((response) => of(GeneralActions.onGetOperatingHoursRequestSuccess(response.data[0].data))),
        catchError(() => of(GeneralActions.onStopFetching()))
      )
    ))
  )
)

export default GetOperatingHoursEpic
